import '.d{display:flex;}.ssr-plugin'
import '.a2{flex-direction:row;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.bo{flex-grow:1;}.ssr-plugin'
import '.l{align-items:center;}.ssr-plugin'
import '.e{justify-content:center;}.ssr-plugin'
import '.k{flex-direction:column;}.ssr-plugin'
import '.az{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.b0{margin-top:2rem;}.ssr-plugin'
import '.b1{margin-bottom:5rem;}.ssr-plugin'
import '.b2{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { InitiativeSideBar } from '@app/components/blocks/sidebar/InitiativeSideBar'
import { ClientOnly } from '@based/sdk/react'

export const InitiativeViewPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <div className="d a2 ae"
      >
        <InitiativeSideBar />
        <div className="bo d l e k"
          style={{
            marginLeft: isMobile ? '3.25rem' : '14rem', // left bar
          }}
        >
          <DashboardNavBar
            initiativeDashboard={true}
            style={{ backgroundColor: 'var(--shades-white)' }}
          />
          <div className="az d k ab b0 b1 b2"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '60%', // 12rem is padding + navbar height
              paddingInline: isMobile ? '1rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
